import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';
import { NzSelectComponent } from 'ng-zorro-antd/select';

import { SelectBaseComponent } from './select-base';

@Component({
  selector: 'app-select-base',
  template: '',
  providers: []
})
export abstract class SelectInstantBaseComponent extends SelectBaseComponent {
  @Output() readonly addingValue = new EventEmitter<any>();
  @Output() readonly openChange = new EventEmitter<boolean>();
  @Input('tabindex') tabIndex: string | null = null;
  enterEvent = false;
  mouseEvent = false;

  constructor(
    http: _HttpClient,
    cdr: ChangeDetectorRef,
    protected router: Router
  ) {
    super(http, cdr);
    this.valueField = '';
  }

  // set the location want to navigate
  abstract jump(): string | undefined;

  // set the param
  abstract queryParam(): String;
  focusInput() {
    if(this.selector && this.selector) {
      this.selector.focus();

    }
  }
  override valueChanged(val: any, isInstantData: boolean = false): void {
    // If the search keyword is not empty, and the search result is not yet loaded,
    // avoid selecting the first item from the dropdown list on Enter key pressed
    if (
      this.searchForm.controls.keyword.value &&
      this.searchForm.controls.keyword.value !==
        this.searchForm.controls.resultKeyword.value
    ) {
      return;
    }

    this.value = val;
    const queryParam = this.queryParam();

    if (isInstantData) {
      var instantData = this.instantData;
      this.clearSelection().then(() => {
        if (this.jump() != undefined) {
          if (instantData) {
            setTimeout(() => {
              this.router.navigate([this.jump()], {
                queryParams: {
                  [queryParam as string]: instantData,
                  autoPopulate: 1
                }
              });
            }, 50);
          } else {
            setTimeout(() => {
              this.router.navigate([this.jump()], {
                queryParams: {
                  autoPopulate: 1
                }
              });
            }, 50);
          }
        }
      });
    } else if (this.valueField) {
      this.selected = this.list.find(x => x[this.valueField] === val);
    } else {
      this.selected = val;
    }
    this.onChange(val);
    this.selectedChange.emit(this.selected);
  }
  // clear the selection if it is add new
  clearSelection(): Promise<void> {
    return new Promise(resolve => {
      if (this.selector) {
        this.selector.clearInput();
        this.selector.blur(); // To ensure the dropdown is closed
        this.value = null;
        this.selected = null;
      }
      // Resolve the promise after clearing the selection
      resolve();
    });
  }

  addNew() {
    console.log('addNew');
    this.addingValue.emit(false);
    this.valueChanged(null, true);
    if (this.selector) this.selector.nzOpen = false;
  }

  handleClick(event: MouseEvent): void {
    this.mouseEvent = true;
  }

  handleKeyDown(event: KeyboardEvent): void {
    const arrowKeys = ['ArrowLeft', 'ArrowRight', 'Escape'];

    // when current position in select component, want to move the left right column, close the option list
    if (
      arrowKeys.includes(event.key) ||
      (event.key === 'Enter' && event.ctrlKey) ||
      event.ctrlKey
    ) {
      if (this.selector?.nzOpen) {
        this.selector.nzOpen = false;
      }
      /**
       * To detect the option list just opened using enter key or event
       * Default action was using ArrowDown to open the option list, Avoid it
       */
      if (this.enterEvent) this.enterEvent = false;
      if (this.mouseEvent) this.mouseEvent = false;
    }

    switch (event.key) {
      case 'ArrowDown':
        // if search value is not empty, mean option list is open, so run default event action for select component
        if (this.instantData) {
          event.stopPropagation();
        } else {
          // if not open by enter key or mouse, did not open the option list
          // default is using arrow down to open the option list, avoid it
          if (this.selector)
            if (!this.enterEvent && !this.mouseEvent) {
              this.selector.nzOpen = false;
            } else {
              event.stopPropagation();
            }
        }
        break;

      // Make sure this component just listen the action from detail page
      case 'ArrowUp':
        if (this.selector) if (this.selector.nzOpen) event.stopPropagation();
        break;

      case 'Enter':
        /**
         * every time press enter key will reverse the boolean value, default it is false
         * to make sure the timing when customer select component selected value
         * that time event = false to make sure process sequence
         */
        if (!this.enterEvent) this.enterEvent = true;
        else this.enterEvent = false;

        /**
         * To double comfirm the option list was closed
         * If Remove below, will happen one situation, after customer select component selected value,
         * and move to next column, the option list will open again
         */
        if (!this.selector?.nzOpen) {
          if (this.selector) this.selector.nzOpen = false;
        }
        break;

      case 'V':
      case 'v':
        if (event.ctrlKey) {
          if (this.selector) {
            this.selector.nzOpen = true;
            this.mouseEvent = false;
            this.enterEvent = false;
          }
        }
        break;
      case 'Space':
        if (this.selector) {
          this.selector.nzOpen = true;
          this.mouseEvent = false;
          this.enterEvent = false;
        }
        break;
      default:
        break;
    }
  }
}
